import "./App.css";
import OrderCorrectionView from "./components/orderCorrectionView";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/toast/dist/style.css";
import "@ingka/focus/dist/style.css";
import "@ingka/table/dist/style.css";
import "@ingka/search/dist/style.css";
import "@ingka/forms/dist/style.css";
import "@ingka/typography/dist/style.css";
import "@ingka/grid/dist/style.css";
import '@ingka/modal/dist/style.css';
import "@ingka/accordion-shared/dist/style.css";
import '@ingka/loading/dist/style.css';
import { useAuth0 } from "@auth0/auth0-react";
import LoggedUser from "./components/loggedUser";
import { setAccessTokenSilently } from "./services/httpService";
import { hasCorrectionPrivilege } from "./services/dfpService";
import styled from "styled-components";
import React, { useEffect, useState } from "react";
// eslint-disable-next-line no-unused-vars
import Button from "@ingka/button";
import { useDispatch } from "react-redux";
import Loading, { LoadingBall } from '@ingka/loading';
import { loadPrivilegeCountries } from "./store/orderCorrectionService/thunks";
import * as actionCreators from "./store/orderCorrectionService/actions";
import OpenMyIdentityDialog from "./components/modelPopup/openMyIdentityDialog";
//import { authConfig } from "./authConfig";

const LoginSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

function App() {
	const { isAuthenticated, user, loginWithRedirect, getAccessTokenSilently } = useAuth0();

  const [privilegeInfo, setPrivilegeInfo] = useState({
    hasPrivilege: false,
    privilegeChecked: false,
    message: "",
    privilegeCountries:[]
  });

  useEffect(() => {
    setAccessTokenSilently(getAccessTokenSilently);
  });

  useEffect(() => {
    if (user) {
      hasCorrectionPrivilege()
        .then(res => {
          setPrivilegeInfo(res);
          return res;
        })
        .catch(error => {
          console.log(error);
          setPrivilegeInfo({
            hasPrivilege: false,
            message: error.message,
            privilegeChecked: true
          });
        });
    }
  }, [user]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (privilegeInfo.hasPrivilege) {
      dispatch(loadPrivilegeCountries(privilegeInfo.privilegeCountries));
      if (privilegeInfo.privilegeCountries.length === 1){
        dispatch(
          actionCreators.setSearchCountry({
            code: privilegeInfo.privilegeCountries[0].countryCode,
            name: privilegeInfo.privilegeCountries[0].countryName,
            isDummy: false
          })
        );
      }
    }
	}, [privilegeInfo, dispatch]);

	if (!isAuthenticated) {
		return (
			<div className="App" >
			<div className="App-header">Order Correction Service</div>
			<LoginSection >
				<Button className="btn"
					type="primary"
					onClick={() => {
						loginWithRedirect();
					}}
				>
					Log in
				</Button>
			</LoginSection>
			</div>
		);
	}

	if (!privilegeInfo.privilegeChecked) {
		return <div>
			<header className="App-header" >Order Correction Service</header>
			<Loading
      text="Checking user privileges"
    >
      <LoadingBall
        color="emphasised"
        size="large"
      />
    </Loading></div>;
	}

  if (!privilegeInfo.hasPrivilege) {
    const userTitle=`Not enough privileges`;
    const userMessage = `You do not have enough privileges to open the Order Correction Service. 
    If access is required, a request can be submitted in Myidentity`;
    return <div><header className="App-header" >Order Correction Service</header>
    <OpenMyIdentityDialog errorTitle={userTitle}
    errorDescription={userMessage}/></div>;
  }

	return (
		<div className="App">
			<header className="App-header" >Order Correction Service
			<LoggedUser/>
			</header>
			<OrderCorrectionView searchCountries={privilegeInfo.privilegeCountries} />
		</div>
	);
}
export default App;
